// LandingPage.js

import React from 'react';
import LoginPage from '../components/auth/LoginPage';

const LandingPage = () => {
    // This completely replaces the marketing page with the Login screen.
    return <LoginPage />;
};

export default LandingPage;